import { useState, useEffect } from 'react';
import { PORTFOLIO, NAV_ITEMS } from '../data';
import './Header.css';

function Header({ activeSection, scrolled, onNavigate }) {
  const [menuOpen, setMenuOpen] = useState(false);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  const navigate = (id) => {
    setMenuOpen(false);
    onNavigate(id);
  };

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <nav className="nav" aria-label="Primary">
        <button className="nav__logo" onClick={() => navigate('home')} aria-label="Home">
          {PORTFOLIO.name.split(' ')[0]}
        </button>

        <ul className="nav__links">
          {NAV_ITEMS.map(({ label, id }) => (
            <li key={id}>
              <button
                className={`nav__link ${activeSection === id ? 'nav__link--active' : ''}`}
                aria-current={activeSection === id ? 'true' : undefined}
                onClick={() => navigate(id)}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>

        <div className="nav__end">
          <a href={`mailto:${PORTFOLIO.email}`} className="nav__cta">
            Get in touch
          </a>
          <button
            className={`nav__toggle ${menuOpen ? 'nav__toggle--open' : ''}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-expanded={menuOpen}
            aria-controls="mobile-menu"
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          >
            <span />
            <span />
          </button>
        </div>
      </nav>

      <div
        id="mobile-menu"
        className={`menu ${menuOpen ? 'menu--open' : ''}`}
        aria-hidden={!menuOpen}
      >
        <ul className="menu__links">
          {NAV_ITEMS.map(({ label, id }, i) => (
            <li key={id} style={{ '--i': i }}>
              <button
                className="menu__link"
                onClick={() => navigate(id)}
                tabIndex={menuOpen ? 0 : -1}
              >
                {label}
              </button>
            </li>
          ))}
        </ul>
        <div className="menu__footer" style={{ '--i': NAV_ITEMS.length }}>
          <a href={`mailto:${PORTFOLIO.email}`} tabIndex={menuOpen ? 0 : -1}>
            {PORTFOLIO.email}
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header;
